import { render, staticRenderFns } from "./TextFieldAndLabel.vue?vue&type=template&id=44a49a91&"
import script from "./TextFieldAndLabel.vue?vue&type=script&lang=js&"
export * from "./TextFieldAndLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports